import { useTranslation } from 'react-i18next'
import Grid from '@config/Grid/Grid'
import tornPaperImage from '@assets/images/torn-paper.png'
import LanguageSelect from '@/shared/components/LanguageSelect/LanguageSelect'
import Button from '@/shared/components/Button/Button'
import styles from './PageNotFound.module.scss'

function PageNotFoundButtonLabel() {
  const { t } = useTranslation()

  return (
    <div className={styles.pageNotFoundButtonLabel}>
      <p className={`${styles.pageNotFoundText} body-bold-medium`}>
        {t('NOT_FOUND.BUTTON_LABEL.FIRST_PART')}{' '}
      </p>
      <p className={`${styles.pageNotFoundText} body-medium-logo`}>
        {t('NOT_FOUND.BUTTON_LABEL.SECOND_PART')}
        <mark className="mark-white">
          {t('NOT_FOUND.BUTTON_LABEL.THIRD_PART')}
        </mark>
      </p>
    </div>
  )
}

function PageNotFound() {
  const { t } = useTranslation()
  const buttonLabel = PageNotFoundButtonLabel()

  return (
    <Grid>
      <div className={`start-5 col-4 ${styles.pageNotFoundWrapper}`}>
        <div className={styles.pageNotFoundContainer}>
          <img
            src={tornPaperImage}
            alt="Torn paper"
            className={styles.tornPaperImage}
          />
          <div className={styles.pageNotFoundContent}>
            <div className={styles.pageNotFoundHeader}>
              <h1 className={`${styles.pageNotFoundTitle} headline-bold-large`}>
                <mark className="mark-orange">
                  {t('NOT_FOUND.TITLE.FIRST_PART')}
                </mark>
                {t('NOT_FOUND.TITLE.SECOND_PART')}
              </h1>
              <LanguageSelect compact dark />
            </div>
            <div className={styles.pageNotFoundTextContainer}>
              <p className={`${styles.pageNotFoundText} title-large`}>
                {t('NOT_FOUND.DESCRIPTION.FIRST_PART')}
              </p>
              <p className={`${styles.pageNotFoundText} title-large`}>
                {t('NOT_FOUND.DESCRIPTION.SECOND_PART')}{' '}
                <mark className="mark-orange">
                  {t('NOT_FOUND.DESCRIPTION.THIRD_PART')}
                </mark>
              </p>
            </div>
            <Button
              onClick={() => {}}
              label={buttonLabel}
              variant="contained"
              color="secondary"
              maxWidth
            />
          </div>
        </div>
      </div>
    </Grid>
  )
}

export default PageNotFound
